import { createAction } from '@reduxjs/toolkit'
import { AppState } from '../../appState'

export const setAIAgentClearSession = createAction('ai/setAIAgentClearSession')

export const setAIAgentClearSessionReducer = (state: AppState['ai']): void => {
  state.popup.list = []
  state.popup.sessionId = null
}
